import { StockOrderFilterValues } from "../../types";

export const filterValuesToApiInput = (
  filterValues: StockOrderFilterValues
) => {
  let v = {};
  if (filterValues?.locationId?.length) {
    v = {
      ...v,
      locationId: {
        in: filterValues.locationId,
      },
    };
  }
  if (filterValues?.productId?.length) {
    v = {
      ...v,
      productId: {
        in: filterValues.productId,
      },
    };
  }
  return v;
};
